import { Box } from "@mui/material";
import { type FC } from "react";

import { ROUTES } from "~/constants/routing";
import { type IInsightTagRef } from "~/feature/insights/types";

import * as Styled from "./InsightTagChips.styles";

interface IInsightTagChipsProps {
  tags: IInsightTagRef[];
}

export const InsightTagChips: FC<IInsightTagChipsProps> = ({ tags }) => {

  if (tags.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {tags.map((tag) => (
        <Styled.TagLink
          key={tag.slug}
          to={ROUTES.insightsTag.createURL(tag.slug)}
        >
          <Styled.TagHash>#</Styled.TagHash>
          <Styled.TagLabel>{tag.name}</Styled.TagLabel>
        </Styled.TagLink>
      ))}
    </Box>
  );
};
